export default __webpack_public_path__ + "425c9bac7b33bb42a7bcf5b6709825c0.svg";